<!--
Copyright 2025 Google LLC. This software is provided as-is, without warranty 
or representation for any use or purpose. Your use of it is subject to your 
agreement with Google.
-->
<mat-sidenav-container class="main-container">
    <!-- <mat-sidenav class="app-menu" mode="side">
        <app-menu></app-menu>
    </mat-sidenav> -->
    <mat-sidenav-content>
        <div class="page-wrapper">
            <app-guidelines></app-guidelines>
        </div>
    </mat-sidenav-content>
</mat-sidenav-container>